export interface IStep1Validation {
    transplantDate: boolean,
    transplantType: boolean,
    nkrAlias: boolean,
    transplantSubType: boolean,
    hasMedicare: boolean,
    other: boolean,
    dirty: boolean
}